module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('nav', {
    staticClass: "bar bar-nav border"
  }, [(_vm.ssoFlag === 0) ? _c('div', {
    staticStyle: {
      "float": "left",
      "width": "86%"
    }
  }, [_c('router-link', {
    staticClass: "tab-item",
    attrs: {
      "to": {
        name: 'finder'
      }
    }
  }, [_c('div', {
    staticClass: "search-input",
    staticStyle: {
      "margin-top": "0.5rem"
    }
  }, [_c('label', {
    staticClass: "icon icon-search",
    attrs: {
      "for": "search"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "search",
      "id": "search",
      "placeholder": "输入基因名称...",
      "readonly": "",
      "unselectable": "on"
    }
  })])])], 1) : _c('div', {
    staticStyle: {
      "float": "left",
      "width": "86%"
    }
  }, [_c('div', {
    staticClass: "search-input",
    staticStyle: {
      "margin-top": "0.5rem"
    }
  }, [_c('label', {
    staticClass: "icon icon-search",
    attrs: {
      "for": "search"
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "open-popup open-goods",
    attrs: {
      "type": "search",
      "id": "search",
      "data-popup": ".popup-goods",
      "placeholder": "查询基因/产品名称……",
      "readonly": "",
      "unselectable": "on"
    },
    on: {
      "click": _vm.onSearchClicked
    }
  })])]), _vm._v(" "), _c('span', {
    staticStyle: {
      "float": "right",
      "width": "12%"
    }
  }, [_c('a', {
    staticClass: "item-link item-content",
    staticStyle: {
      "float": "right",
      "position": "relative",
      "margin-top": "4px"
    },
    on: {
      "click": function($event) {
        return _vm.gotoMymessage()
      }
    }
  }, [_c('img', {
    staticStyle: {
      "width": "2.2rem",
      "height": "2rem"
    },
    attrs: {
      "src": "/static/img/kefu.png"
    }
  }), _vm._v(" "), (_vm.curMessageSession.unreadMessagesAmount > 0) ? _c('span', {
    staticClass: "unreadmessage"
  }, [_vm._v("\n           " + _vm._s(_vm.curMessageSession.unreadMessagesAmount))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', [_c('div', {
    staticStyle: {
      "margin-bottom": ".5rem",
      "color": "black",
      "margin-left": ".2rem",
      "font-size": ".7rem"
    }
  }, [_vm._v("过表达/干扰现货慢病毒")]), _vm._v(" "), _c('div', {
    staticClass: "newCategory-items"
  }, _vm._l((_vm.newList), function(o) {
    return _c('div', {
      staticClass: "newCategory-item",
      on: {
        "click": function($event) {
          return _vm.todCategoryDetailnew(o)
        }
      }
    }, [_c('div', {
      staticClass: "item-label"
    }, [_vm._v(_vm._s(o.label))]), _vm._v(" "), _c('img', {
      staticClass: "imgs",
      attrs: {
        "src": _vm.baseurl + o.srcImg
      }
    })])
  }), 0)]), _vm._v(" "), _c('div', [_c('div', {
    staticStyle: {
      "margin-bottom": ".5rem",
      "color": "black",
      "margin-left": ".2rem",
      "font-size": ".7rem"
    }
  }, [_vm._v("现货产品\n        ")]), _vm._v(" "), _vm._l((_vm.tabs1), function(tabs) {
    return _c('div', {
      staticStyle: {
        "margin-bottom": "0.6rem"
      }
    }, [_c('table', {
      attrs: {
        "border": "0",
        "cellpadding": "0",
        "cellspacing": "0",
        "width": "100%"
      }
    }, [(tabs[3]) ? _c('tr', [(tabs[0] && tabs[1]) ? _c('td', {
      staticStyle: {
        "width": "20%"
      }
    }, [_c('div', {
      staticClass: "tab-label"
    }, [_vm._v(_vm._s(tabs[0].categoryLabel))]), _vm._v(" "), _c('div', {
      staticStyle: {
        "height": "4.8rem"
      },
      style: ({
        'background-image': 'url(' + _vm.baseurl + tabs[0].categoryIcon + ') ',
        'background-size': '100% 100%'
      }),
      on: {
        "click": function($event) {
          return _vm.todCategoryDetail(tabs[0].categoryId, tabs[0].categoryLabel)
        }
      }
    })]) : _vm._e(), _vm._v(" "), (tabs[1]) ? _c('td', {
      staticStyle: {
        "width": "20%"
      }
    }, [_c('div', {
      staticClass: "tab-label"
    }, [_vm._v(_vm._s(tabs[1].categoryLabel))]), _vm._v(" "), (tabs[1]) ? _c('div', {
      staticStyle: {
        "margin-left": "0.5rem",
        "height": "4.8rem"
      },
      style: ({
        'background-image': 'url(' + _vm.baseurl + tabs[1].categoryIcon + ') ',
        'background-size': '100% 100%'
      }),
      on: {
        "click": function($event) {
          return _vm.todCategoryDetail(tabs[1].categoryId, tabs[1].categoryLabel)
        }
      }
    }) : _vm._e()]) : _vm._e(), _vm._v(" "), (tabs[2]) ? _c('td', {
      staticStyle: {
        "width": "20%"
      }
    }, [_c('div', {
      staticClass: "tab-label"
    }, [_vm._v(_vm._s(tabs[2].categoryLabel))]), _vm._v(" "), (tabs[1]) ? _c('div', {
      staticStyle: {
        "margin-left": "0.5rem",
        "height": "4.8rem"
      },
      style: ({
        'background-image': 'url(' + _vm.baseurl + tabs[2].categoryIcon + ') ',
        'background-size': '100% 100%'
      }),
      on: {
        "click": function($event) {
          return _vm.todCategoryDetail(tabs[2].categoryId, tabs[2].categoryLabel)
        }
      }
    }) : _vm._e()]) : _vm._e(), _vm._v(" "), (tabs[3]) ? _c('td', {
      staticStyle: {
        "width": "20%"
      }
    }, [_c('div', {
      staticClass: "tab-label"
    }, [_vm._v(_vm._s(tabs[3].categoryLabel))]), _vm._v(" "), _c('div', {
      staticStyle: {
        "margin-left": "0.5rem",
        "height": "4.8rem"
      },
      style: ({
        'background-image': 'url(' + _vm.baseurl + tabs[3].categoryIcon + ') ',
        'background-size': '100% 100%'
      }),
      on: {
        "click": function($event) {
          return _vm.todCategoryDetail(tabs[3].categoryId, tabs[3].categoryLabel)
        }
      }
    })]) : _vm._e()]) : _c('tr', [(tabs[0] && tabs[1]) ? _c('td', {
      staticStyle: {
        "width": "20%"
      }
    }, [_c('div', {
      staticClass: "tab-label"
    }, [_vm._v(_vm._s(tabs[0].categoryLabel))]), _vm._v(" "), _c('div', {
      staticStyle: {
        "height": "4.8rem"
      },
      style: ({
        'background-image': 'url(' + _vm.baseurl + tabs[0].categoryIcon + ') ',
        'background-size': '100% 100%'
      }),
      on: {
        "click": function($event) {
          return _vm.todCategoryDetail(tabs[0].categoryId, tabs[0].categoryLabel)
        }
      }
    })]) : _vm._e(), _vm._v(" "), (tabs[0] && !tabs[1]) ? _c('td', {
      staticStyle: {
        "width": "6.5%"
      }
    }, [_c('div', {
      staticClass: "tab-label"
    }, [_vm._v(_vm._s(tabs[0].categoryLabel))]), _vm._v(" "), _c('div', {
      staticStyle: {
        "height": "4.8rem"
      },
      style: ({
        'background-image': 'url(' + _vm.baseurl + tabs[0].categoryIcon + ') ',
        'background-size': '100% 100%'
      }),
      on: {
        "click": function($event) {
          return _vm.todCategoryDetail(tabs[0].categoryId, tabs[0].categoryLabel)
        }
      }
    })]) : _vm._e(), _vm._v(" "), (tabs[1]) ? _c('td', {
      staticStyle: {
        "width": "20%"
      }
    }, [_c('div', {
      staticClass: "tab-label"
    }, [_vm._v(_vm._s(tabs[1].categoryLabel))]), _vm._v(" "), (tabs[1]) ? _c('div', {
      staticStyle: {
        "margin-left": "0.5rem",
        "height": "4.8rem"
      },
      style: ({
        'background-image': 'url(' + _vm.baseurl + tabs[1].categoryIcon + ') ',
        'background-size': '100% 100%'
      }),
      on: {
        "click": function($event) {
          return _vm.todCategoryDetail(tabs[1].categoryId, tabs[1].categoryLabel)
        }
      }
    }) : _vm._e()]) : _vm._e(), _vm._v(" "), (tabs[2]) ? _c('td', {
      staticStyle: {
        "width": "20%"
      }
    }, [_c('div', {
      staticClass: "tab-label"
    }, [_vm._v(_vm._s(tabs[2].categoryLabel))]), _vm._v(" "), (tabs[1]) ? _c('div', {
      staticStyle: {
        "margin-left": "0.5rem",
        "height": "4.8rem"
      },
      style: ({
        'background-image': 'url(' + _vm.baseurl + tabs[2].categoryIcon + ') ',
        'background-size': '100% 100%'
      }),
      on: {
        "click": function($event) {
          return _vm.todCategoryDetail(tabs[2].categoryId, tabs[2].categoryLabel)
        }
      }
    }) : _vm._e()]) : _vm._e(), _vm._v(" "), (tabs[2]) ? _c('td', {
      staticStyle: {
        "width": "20%"
      }
    }, [_c('div')]) : _vm._e(), _vm._v(" "), (!tabs[2]) ? _c('td', {
      staticStyle: {
        "width": "40%"
      }
    }, [_c('div')]) : _vm._e()])])])
  }), _vm._v(" "), (_vm.ssoFlag !== 1) ? _c('div', {
    staticStyle: {
      "margin-bottom": ".5rem",
      "color": "black",
      "margin-left": ".2rem",
      "font-size": ".7rem"
    }
  }, [_vm._v("更多产品\n        ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.tabs2), function(tabs) {
    return (_vm.ssoFlag !== 1) ? _c('div', {
      staticStyle: {
        "margin-bottom": "0.6rem"
      }
    }, [_c('table', {
      attrs: {
        "border": "0",
        "cellpadding": "0",
        "cellspacing": "0",
        "width": "100%"
      }
    }, [(tabs[3]) ? _c('tr', [(tabs[0] && tabs[1]) ? _c('td', {
      staticStyle: {
        "width": "20%"
      }
    }, [_c('div', {
      staticStyle: {
        "height": "4.8rem"
      },
      style: ({
        'background-image': 'url(' + _vm.baseurl + tabs[0].categoryIcon + ') ',
        'background-size': '100% 100%'
      }),
      on: {
        "click": function($event) {
          return _vm.todCategoryDetail(tabs[0].categoryId, tabs[0].categoryLabel)
        }
      }
    })]) : _vm._e(), _vm._v(" "), (tabs[1]) ? _c('td', {
      staticStyle: {
        "width": "20%"
      }
    }, [(tabs[1]) ? _c('div', {
      staticStyle: {
        "margin-left": "0.5rem",
        "height": "4.8rem"
      },
      style: ({
        'background-image': 'url(' + _vm.baseurl + tabs[1].categoryIcon + ') ',
        'background-size': '100% 100%'
      }),
      on: {
        "click": function($event) {
          return _vm.todCategoryDetail(tabs[1].categoryId, tabs[1].categoryLabel)
        }
      }
    }) : _vm._e()]) : _vm._e(), _vm._v(" "), (tabs[2]) ? _c('td', {
      staticStyle: {
        "width": "20%"
      }
    }, [(tabs[1]) ? _c('div', {
      staticStyle: {
        "margin-left": "0.5rem",
        "height": "4.8rem"
      },
      style: ({
        'background-image': 'url(' + _vm.baseurl + tabs[2].categoryIcon + ') ',
        'background-size': '100% 100%'
      }),
      on: {
        "click": function($event) {
          return _vm.todCategoryDetail(tabs[2].categoryId, tabs[2].categoryLabel)
        }
      }
    }) : _vm._e()]) : _vm._e(), _vm._v(" "), (tabs[3]) ? _c('td', {
      staticStyle: {
        "width": "20%"
      }
    }, [_c('div', {
      staticStyle: {
        "margin-left": "0.5rem",
        "height": "4.8rem"
      },
      style: ({
        'background-image': 'url(' + _vm.baseurl + tabs[3].categoryIcon + ') ',
        'background-size': '100% 100%'
      }),
      on: {
        "click": function($event) {
          return _vm.todCategoryDetail(tabs[3].categoryId, tabs[3].categoryLabel)
        }
      }
    })]) : _vm._e()]) : _c('tr', [(tabs[0] && tabs[1]) ? _c('td', {
      staticStyle: {
        "width": "10%"
      }
    }, [_c('div', {
      staticStyle: {
        "height": "4.8rem"
      },
      style: ({
        'background-image': 'url(' + _vm.baseurl + tabs[0].categoryIcon + ') ',
        'background-size': '100% 100%'
      }),
      on: {
        "click": function($event) {
          return _vm.todCategoryDetail(tabs[0].categoryId, tabs[0].categoryLabel)
        }
      }
    })]) : _vm._e(), _vm._v(" "), (tabs[0] && !tabs[1]) ? _c('td', {
      staticStyle: {
        "width": "6.5%"
      }
    }, [_c('div', {
      staticStyle: {
        "height": "4.8rem"
      },
      style: ({
        'background-image': 'url(' + _vm.baseurl + tabs[0].categoryIcon + ') ',
        'background-size': '100% 100%'
      }),
      on: {
        "click": function($event) {
          return _vm.todCategoryDetail(tabs[0].categoryId, tabs[0].categoryLabel)
        }
      }
    })]) : _vm._e(), _vm._v(" "), (tabs[1]) ? _c('td', {
      staticStyle: {
        "width": "10%"
      }
    }, [(tabs[1]) ? _c('div', {
      staticStyle: {
        "margin-left": "0.5rem",
        "height": "4.8rem"
      },
      style: ({
        'background-image': 'url(' + _vm.baseurl + tabs[1].categoryIcon + ') ',
        'background-size': '100% 100%'
      }),
      on: {
        "click": function($event) {
          return _vm.todCategoryDetail(tabs[1].categoryId, tabs[1].categoryLabel)
        }
      }
    }) : _vm._e()]) : _vm._e(), _vm._v(" "), (tabs[2]) ? _c('td', {
      staticStyle: {
        "width": "20%"
      }
    }, [(tabs[1]) ? _c('div', {
      staticStyle: {
        "margin-left": "0.5rem",
        "height": "4.8rem"
      },
      style: ({
        'background-image': 'url(' + _vm.baseurl + tabs[2].categoryIcon + ') ',
        'background-size': '100% 100%'
      }),
      on: {
        "click": function($event) {
          return _vm.todCategoryDetail(tabs[2].categoryId, tabs[2].categoryLabel)
        }
      }
    }) : _vm._e()]) : _vm._e(), _vm._v(" "), _vm._m(0, true)])])]) : _vm._e()
  })], 2)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticStyle: {
      "width": "20%"
    }
  }, [_c('div')])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-526b6608","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Category/Category.vue
// module id = 1635
// module chunks = 8